import { Component, Vue } from 'nuxt-property-decorator'

@Component
export class SiteNavigationMixin extends Vue {
  get blogURL () {
    const { locale } = this.$i18n

    return `/${locale}/blogs/`
  }
}
